module.exports = __webpack_public_path__ + "img/debit.96e2d9f5.svg";